import SHUserPicker from './src/picker.vue';

/* istanbul ignore next */
SHUserPicker.install = function(Vue) {
  Vue.component('sh-user-picker', SHUserPicker);
};

export default SHUserPicker;



// WEBPACK FOOTER //
// ./src/components/base/view/Org/cmps/user/picker/index.js